import { FC, useState } from 'react';
import { Button, Select } from 'antd';

interface StepTwoProps {
  previous: () => void;
  next: () => void;
}

const StepTwo: FC<StepTwoProps> = ({ next }) => {
  const [access, setAccess] = useState('');
  const [accessAlert, setAccessAlert] = useState(false);

  return (
    <div className="w-full space-y-6">
      <h4 className="text-wrap text-center text-2xl font-bold text-primary">
        Connect your accounts in seconds
      </h4>

      <div className="mx-auto min-w-[280px] max-w-[50%] text-center text-gray-500">
        <div className="mb-3">
          We use Leadsie to securely access your ad accounts, pages, and
          analytics without passwords. This gives us the permissions needed to
          manage or review your platforms. Not using us for ads or social? Skip
          this step.
        </div>

        <a
          href="https://app.leadsie.com/connect/sgm/manage"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button type="primary" className="mb-3">
            Provide access now
          </Button>
        </a>
      </div>

      <div className="flex items-center justify-center">
        <Select
          className={`w-auto truncate md:min-w-[250px] ${
            accessAlert
              ? 'rounded-md border border-red-500'
              : 'rounded-md border border-gray-300'
          }`}
          placeholder="Select an option"
          optionFilterProp="children"
          onChange={(value) => setAccess(value)}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          popupMatchSelectWidth={false}
          options={[
            {
              value: 'access_provided',
              label: `I’ve provided access`,
            },
            {
              value: 'access_not_provided',
              label: `I don't want to provide access now`,
            },
          ]}
        />
      </div>

      <div className="flex items-center justify-between gap-4">
        <Button disabled>Back</Button>

        <Button
          type="primary"
          onClick={() => {
            if (access) {
              next();
              return;
            }
            setAccessAlert(true);
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default StepTwo;
